import React from "react";

const BasketIcon = (props) => (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 128 128" {...props} fill={props.color}>
        <g>
            <path
                d="M126.2,42c-0.6-0.6-1.4-1-2.2-1h-7.8l-9.4-31.8C106.5,7.9,105.3,7,104,7H86.5c-1.2-3.5-4.6-6-8.5-6H50
		c-3.9,0-7.2,2.5-8.5,6H24c-1.3,0-2.5,0.9-2.9,2.2L11.8,41H4c-0.9,0-1.7,0.4-2.2,1S0.9,43.5,1,44.4l8.9,71.2
		c0.8,6.5,6.4,11.4,12.9,11.4h82.3c6.5,0,12.1-4.9,12.9-11.4l8.9-71.2C127.1,43.5,126.8,42.7,126.2,42z M50,7h28c1.7,0,3,1.3,3,3
		s-1.3,3-3,3H50c-1.7,0-3-1.3-3-3S48.3,7,50,7z M26.2,13h15.3c1.2,3.5,4.6,6,8.5,6h28c3.9,0,7.2-2.5,8.5-6h15.3l8.2,28H18L26.2,13z
		 M112.1,114.9c-0.4,3.5-3.4,6.1-6.9,6.1H22.8c-3.5,0-6.5-2.6-6.9-6.1L7.4,47h113.2L112.1,114.9z"
            />
            <path
                d="M31,104.4c0.2,1.5,1.5,2.6,3,2.6c0.1,0,0.2,0,0.4,0c1.6-0.2,2.8-1.7,2.6-3.3l-5-40c-0.2-1.6-1.7-2.8-3.3-2.6
		c-1.6,0.2-2.8,1.7-2.6,3.3L31,104.4z"
            />
            <path d="M54,107c1.7,0,3-1.3,3-3V64c0-1.7-1.3-3-3-3s-3,1.3-3,3v40C51,105.7,52.3,107,54,107z" />
            <path d="M74,107c1.7,0,3-1.3,3-3V64c0-1.7-1.3-3-3-3s-3,1.3-3,3v40C71,105.7,72.3,107,74,107z" />
            <path
                d="M93.6,107c0.1,0,0.3,0,0.4,0c1.5,0,2.8-1.1,3-2.6l5-40c0.2-1.6-1-3.1-2.6-3.3c-1.6-0.2-3.1,1-3.3,2.6l-5,40
		C90.8,105.3,92,106.8,93.6,107z"
            />
        </g>
    </svg>
);

const BrandModelIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="100px" height="100px" {...props} fill={props.color}>
        <g>
            <path d="M32,6c-0.553,0-1,0.448-1,1v2c0,0.552,0.447,1,1,1s1-0.448,1-1V7C33,6.448,32.553,6,32,6z" />
            <path d="M37,10c0.553,0,1-0.448,1-1V7c0-0.552-0.447-1-1-1s-1,0.448-1,1v2C36,9.552,36.447,10,37,10z" />
            <path d="M42,10c0.553,0,1-0.448,1-1V7c0-0.552-0.447-1-1-1s-1,0.448-1,1v2C41,9.552,41.447,10,42,10z" />
            <path d="M47,10c0.553,0,1-0.448,1-1V7c0-0.552-0.447-1-1-1s-1,0.448-1,1v2C46,9.552,46.447,10,47,10z" />
            <path d="M52,10c0.553,0,1-0.448,1-1V7c0-0.552-0.447-1-1-1s-1,0.448-1,1v2C51,9.552,51.447,10,52,10z" />
            <path d="M62.488,41.43l-2.123-3.185c-0.31-0.464-0.563-0.965-0.754-1.49L58.609,34H59c2.206,0,4-1.794,4-4V18.667c0-1.934-0.639-3.852-1.8-5.4l-1.13-1.506c-0.134-0.178-0.248-0.374-0.34-0.581L56.97,4.97C56.169,3.166,54.375,2,52.4,2H31.6c-1.975,0-3.769,1.166-4.569,2.969l-2.898,6.521L22.25,14H11.802c-2.096,0-3.983,1.323-4.698,3.291l-2.716,7.464c-0.189,0.524-0.443,1.025-0.753,1.49L1.512,29.43C0.522,30.914,0,32.64,0,34.422V42v1v3c0,2.206,1.794,4,4,4h2c2.206,0,4-1.794,4-4v-2l8.343,0C18.124,44.784,18,45.595,18,46.422V54v1v3c0,2.206,1.794,4,4,4h2c2.206,0,4-1.794,4-4v-2l26,0v2c0,2.206,1.794,4,4,4h2c2.206,0,4-1.794,4-4v-3v-1v-7.578C64,44.64,63.478,42.914,62.488,41.43z M25.8,12.6c0.045-0.06,0.083-0.125,0.114-0.194l2.944-6.625C29.339,4.699,30.415,4,31.6,4H52.4c1.185,0,2.261,0.699,2.741,1.782l2.761,6.21c0.068,0.153,0.146,0.3,0.228,0.444l-2.155,1.055C55.295,13.824,54.535,14,53.777,14H41.021c-0.553,0-1,0.448-1,1s0.447,1,1,1h12.757c1.061,0,2.124-0.247,3.077-0.712l2.459-1.204l0.287,0.382C60.503,15.67,61,17.162,61,18.667V30c0,1.103-0.897,2-2,2h-1.118l-0.985-2.708C56.182,27.323,54.294,26,52.198,26h-9.976c-0.241-0.395-0.453-0.809-0.611-1.246L40.973,23h8.194c0.553,0,1-0.448,1-1s-0.447-1-1-1h-8.921l-1.349-3.708C38.182,15.323,36.294,14,34.198,14H24.75L25.8,12.6z M49,36c-2.414,0-4.434,1.721-4.899,4H28.319c-0.765,0-1.531-0.179-2.217-0.519l-2.239-1.108c0.151-0.305,0.289-0.616,0.404-0.936l2.715-7.464C27.412,28.793,28.545,28,29.802,28h22.396c1.257,0,2.39,0.793,2.819,1.975l2.714,7.462c0.122,0.337,0.265,0.666,0.426,0.986l-2.182,1.068c-0.644,0.315-1.36,0.485-2.078,0.502C53.431,37.717,51.412,36,49,36z M51.816,40h-5.631c0.414-1.161,1.514-2,2.816-2S51.402,38.839,51.816,40z M8,46c0,1.103-0.897,2-2,2H4c-1.103,0-2-0.897-2-2v-2h6V46z M19.189,42L2,42v-7.578c0-1.386,0.406-2.729,1.176-3.883l1.636-2.454l2.404,1.189C8.176,29.749,9.249,30,10.319,30h11.639c0.553,0,1-0.448,1-1s-0.447-1-1-1H10.319c-0.765,0-1.531-0.179-2.217-0.519l-2.239-1.108c0.151-0.305,0.289-0.616,0.404-0.936l2.715-7.464C9.412,16.793,10.545,16,11.802,16h22.396c1.257,0,2.39,0.793,2.819,1.975l2.714,7.462c0.07,0.192,0.157,0.377,0.242,0.563H29.802c-2.096,0-3.983,1.323-4.698,3.291l-2.716,7.464c-0.033,0.091-0.078,0.177-0.115,0.266C22.236,37.017,22.205,37,22.167,37h-9.25c-0.553,0-1,0.448-1,1s0.447,1,1,1h8.215l-1.62,2.43C19.39,41.613,19.297,41.81,19.189,42z M26,58c0,1.103-0.897,2-2,2h-2c-1.103,0-2-0.897-2-2v-2h6V58z M62,58c0,1.103-0.897,2-2,2h-2c-1.103,0-2-0.897-2-2v-2h6V58z M62,54l-42,0v-7.578c0-1.386,0.406-2.729,1.176-3.883l1.636-2.454l2.404,1.189C26.176,41.749,27.249,42,28.319,42h25.458c1.061,0,2.124-0.247,3.077-0.712l2.364-1.157l1.606,2.408C61.594,43.693,62,45.036,62,46.422V54z" />
            <path d="M47.167,48h-12.25c-0.553,0-1,0.448-1,1s0.447,1,1,1h12.25c0.553,0,1-0.448,1-1S47.72,48,47.167,48z" />
            <path d="M52.917,23h4.25c0.553,0,1-0.448,1-1s-0.447-1-1-1h-4.25c-0.553,0-1,0.448-1,1S52.364,23,52.917,23z" />
            <path d="M9.167,37h-4.25c-0.553,0-1,0.448-1,1s0.447,1,1,1h4.25c0.553,0,1-0.448,1-1S9.72,37,9.167,37z" />
            <path d="M26.167,19c0-0.552-0.447-1-1-1h-4.25c-0.553,0-1,0.448-1,1s0.447,1,1,1h4.25C25.72,20,26.167,19.552,26.167,19z" />
            <path d="M43.167,30h-4.25c-0.553,0-1,0.448-1,1s0.447,1,1,1h4.25c0.553,0,1-0.448,1-1S43.72,30,43.167,30z" />
            <path d="M30.248,46.898l-6-0.75c-0.568-0.071-1.141,0.105-1.571,0.485C22.247,47.013,22,47.56,22,48.133V50c0,1.103,0.897,2,2,2h6c1.103,0,2-0.897,2-2v-1.117C32,47.876,31.247,47.023,30.248,46.898z M24,50v-1.867l6,0.75L30.001,50H24z" />
            <path d="M57.752,46.148l-6,0.75C50.753,47.023,50,47.876,50,48.883V50c0,1.103,0.897,2,2,2h6c1.103,0,2-0.897,2-2v-1.867c0-0.573-0.247-1.12-0.677-1.5C58.895,46.254,58.324,46.078,57.752,46.148z M52,50v-1.117l6-0.75L58.001,50H52z" />
        </g>
    </svg>
);

const CarSelectorIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" {...props} fill={props.color}>
        <path d="M 64 26.800781 C 53 26.800781 46.800391 27.099609 35.900391 27.599609 L 34.900391 27.599609 C 30.000391 27.799609 25.699219 30.799219 23.699219 35.199219 L 12.699219 59.599609 C 12.699219 59.699609 12.599609 59.800391 12.599609 59.900391 C 9.2996094 59.600391 6.5003906 59.2 4.4003906 59 C 2.8003906 58.8 1.2996094 59.999609 1.0996094 61.599609 C 0.89960938 63.199609 2.0992188 64.700391 3.6992188 64.900391 C 13.999219 66.200391 40.6 69 64 69 C 87.4 69 114.00078 66.2 124.30078 65 C 126.00078 64.8 127.2 63.299219 127 61.699219 C 126.8 60.099219 125.29922 58.899609 123.69922 59.099609 C 121.59922 59.299609 118.8 59.7 115.5 60 C 115.5 59.9 115.40039 59.799219 115.40039 59.699219 L 104.30078 35.400391 C 102.30078 31.000391 97.999609 28.000781 93.099609 27.800781 L 92.099609 27.800781 C 81.199609 27.100781 75 26.800781 64 26.800781 z M 64 32.800781 C 74.9 32.800781 80.700781 33.099609 91.800781 33.599609 L 92.800781 33.599609 C 95.400781 33.699609 97.700781 35.299219 98.800781 37.699219 L 109.09961 60.5 C 96.599609 61.7 79.6 63 64 63 C 48.4 63 31.400391 61.7 18.900391 60.5 L 29.199219 37.699219 C 30.299219 35.299219 32.599219 33.699609 35.199219 33.599609 L 36.199219 33.599609 C 47.299219 32.999609 53.1 32.800781 64 32.800781 z M 14 73 C 6.8 73 1 78.8 1 86 L 1 104 C 1 107.9 3.5 111.2 7 112.5 L 7 124 C 7 125.7 8.3 127 10 127 L 30 127 C 31.7 127 33 125.7 33 124 L 33 113 L 95 113 L 95 124 C 95 125.7 96.3 127 98 127 L 118 127 C 119.7 127 121 125.7 121 124 L 121 112.5 C 124.5 111.3 127 107.9 127 104 L 127 86 C 127 78.8 121.2 73 114 73 C 106.8 73 101 78.8 101 86 C 101 93.2 106.8 99 114 99 C 116.6 99 119 98.200391 121 96.900391 L 121 104 C 121 105.7 119.7 107 118 107 L 10 107 C 8.3 107 7 105.7 7 104 L 7 96.900391 C 9 98.200391 11.4 99 14 99 C 21.2 99 27 93.2 27 86 C 27 78.8 21.2 73 14 73 z M 14 79 C 17.9 79 21 82.1 21 86 C 21 89.9 17.9 93 14 93 C 10.1 93 7 89.9 7 86 C 7 82.1 10.1 79 14 79 z M 114 79 C 117.9 79 121 82.1 121 86 C 121 89.9 117.9 93 114 93 C 110.1 93 107 89.9 107 86 C 107 82.1 110.1 79 114 79 z M 42 91 C 40.3 91 39 92.3 39 94 C 39 95.7 40.3 97 42 97 L 86 97 C 87.7 97 89 95.7 89 94 C 89 92.3 87.7 91 86 91 L 42 91 z M 13 113 L 27 113 L 27 121 L 13 121 L 13 113 z M 101 113 L 115 113 L 115 121 L 101 121 L 101 113 z" />
    </svg>
);

const CompetitivenessIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props} stroke={props.color}>
        <circle cx="25" cy="25" r="1" />
        <circle cx="28" cy="22" r="1" />
        <circle cx="31" cy="19" r="1" />
        <circle cx="37" cy="13" r="1" />
        <circle cx="34" cy="16" r="1" />
        <circle cx="16" cy="34" r="1" />
        <circle cx="40" cy="10" r="1" />
        <circle cx="43" cy="7" r="1" />
        <circle cx="46" cy="4" r="1" />
        <circle cx="22" cy="28" r="1" />
        <circle cx="19" cy="31" r="1" />
        <circle cx="13" cy="37" r="1" />
        <circle cx="10" cy="40" r="1" />
        <circle cx="7" cy="43" r="1" />
        <circle cx="4" cy="46" r="1" />
        <g>
            <path d="M32.008,38.893v-7.264h-2.816v-1.712c2.093,0,3.216-1.798,3.28-2.225h1.808v11.2H32.008z" />
        </g>
        <path
            style={{
                fill: "none",
                strokeWidth: 2,
                // "strokeLine": "round",
                // "capstrokeLinejoin":"round",
                strokeMiterlimit: 10,
            }}
            d="M30.956,16.134C30.507,8.808,24.44,3,17,3C9.268,3,3,9.268,3,17c0,7.44,5.808,13.507,13.134,13.956"
        />
        <path
            style={{
                fill: "none",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10,
            }}
            d="M19.044,33.866C19.493,41.192,25.56,47,33,47c7.732,0,14-6.268,14-14c0-7.44-5.808-13.507-13.134-13.956"
        />
        <g>
            <path d="M15.808,13.005l-0.448,2.544l0.032,0.032c0.309-0.31,0.903-0.864,2.192-0.864c3.049,0,3.456,3.035,3.456,3.809c0,1.475-1.107,4.016-4.16,4.016c-3.213,0-4.182-2.19-4.16-3.536h2.272c0.053,0.512,0.424,1.68,1.84,1.68c1.522,0,1.936-1.463,1.936-2.159c0-1.956-1.574-2.097-1.936-2.097c-1.015,0-1.488,0.587-1.712,0.896h-2.048l1.104-6.192h6.256v1.872H15.808z" />
        </g>
    </svg>
);

const DashboardIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props} fill={props.color}>
        <path d="M 25 2 C 12.354545 2 2 12.354545 2 25 C 2 37.645455 12.354545 48 25 48 C 37.645455 48 48 37.645455 48 25 C 48 12.354545 37.645455 2 25 2 z M 25 4 C 36.554545 4 46 13.445455 46 25 C 46 36.554545 36.554545 46 25 46 C 13.445455 46 4 36.554545 4 25 C 4 13.445455 13.445455 4 25 4 z M 24.984375 5.8789062 A 1.0001 1.0001 0 0 0 24 6.8945312 L 24 8.953125 A 1.0001 1.0001 0 1 0 26 8.953125 L 26 6.8945312 A 1.0001 1.0001 0 0 0 24.984375 5.8789062 z M 15.892578 8.3007812 A 1.0001 1.0001 0 0 0 15.097656 9.8261719 L 16.171875 11.617188 A 1.0001 1.0001 0 1 0 17.886719 10.587891 L 16.8125 8.796875 A 1.0001 1.0001 0 0 0 15.892578 8.3007812 z M 34.078125 8.3007812 A 1.0001 1.0001 0 0 0 33.1875 8.796875 L 32.113281 10.587891 A 1.0001 1.0001 0 1 0 33.828125 11.617188 L 34.902344 9.8261719 A 1.0001 1.0001 0 0 0 34.078125 8.3007812 z M 9.359375 14.84375 A 1.0001 1.0001 0 0 0 8.9042969 16.707031 L 10.695312 17.78125 A 1.0001 1.0001 0 1 0 11.722656 16.066406 L 9.9316406 14.992188 A 1.0001 1.0001 0 0 0 9.359375 14.84375 z M 40.027344 15 A 1.0001 1.0001 0 0 0 39.640625 15.066406 L 23.652344 21.228516 A 1.0001 1.0001 0 0 0 23.185547 21.599609 C 21.931912 22.266866 21 23.474558 21 25 C 21 27.209804 22.790196 29 25 29 C 25.690891 29 26.258107 28.68094 26.820312 28.380859 A 1.0001 1.0001 0 0 0 27.509766 28.140625 L 40.654297 16.755859 A 1.0001 1.0001 0 0 0 40.027344 15 z M 35.017578 18.992188 L 26.318359 26.527344 A 1.0001 1.0001 0 0 0 26.238281 26.582031 C 25.898116 26.844731 25.49009 27 25 27 C 23.809804 27 23 26.190196 23 25 C 23 24.057093 23.530471 23.384107 24.330078 23.119141 A 1.0001 1.0001 0 0 0 24.482422 23.052734 L 35.017578 18.992188 z M 7 23.894531 A 1.0001 1.0001 0 1 0 7 25.894531 L 9.0605469 25.894531 A 1.0001 1.0001 0 1 0 9.0605469 23.894531 L 7 23.894531 z M 40.939453 23.894531 A 1.0001 1.0001 0 1 0 40.939453 25.894531 L 43 25.894531 A 1.0001 1.0001 0 1 0 43 23.894531 L 40.939453 23.894531 z M 11.236328 31.857422 A 1.0001 1.0001 0 0 0 10.695312 32.005859 L 8.9042969 33.082031 A 1.0001 1.0001 0 1 0 9.9335938 34.796875 L 11.724609 33.720703 A 1.0001 1.0001 0 0 0 11.236328 31.857422 z M 38.734375 31.857422 A 1.0001 1.0001 0 0 0 38.275391 33.720703 L 40.066406 34.796875 A 1.0001 1.0001 0 1 0 41.095703 33.082031 L 39.304688 32.005859 A 1.0001 1.0001 0 0 0 38.734375 31.857422 z" />
    </svg>
);

const DataCoverageIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="100px" height="100px" {...props}>
        <rect x="2" y="2" style={{ fill: "none" }} width="46" height="46" />
        <circle
            style={{
                fill: "none",
                stroke: props.color,
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeMiterlimit: 10,
            }}
            cx="25"
            cy="25"
            r="22.08"
        />
        <ellipse
            style={{
                fill: "none",
                stroke: props.color,
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeMiterlimit: 10,
            }}
            cx="25"
            cy="25"
            rx="11.04"
            ry="22.08"
        />
        <path
            style={{
                fill: "none",
                stroke: props.color,
                strokeWidth: 2,
                strokeMiterlimit: 10,
            }}
            d="M7.888,39.048C11.936,36.564,18.1,35,25,35c6.808,0,12.88,1.564,17.02,3.956"
        />
        <path
            style={{
                fill: "none",
                stroke: props.color,
                strokeWidth: 2,
                strokeMiterlimit: 10,
            }}
            d="M42.112,10.952C38.064,13.436,31.9,15,25,15c-6.808,0-12.88-1.564-17.02-3.956"
        />
        <line
            style={{
                fill: "none",
                stroke: props.color,
                strokeWidth: 2,
                strokeMiterlimit: 10,
            }}
            x1="2.92"
            y1="25"
            x2="47.08"
            y2="25"
        />
        <line
            style={{
                fill: "none",
                stroke: props.color,
                strokeWidth: 2,
                strokeMiterlimit: 10,
            }}
            x1="25"
            y1="2.92"
            x2="25"
            y2="47.08"
        />
    </svg>
);

const ExportIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="100px" height="100px" stroke={props.color} {...props}>
        <polyline fill="none" stroke={props.color} stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" points="39.11,16.11 48,25 39.11,33.89 " />
        <line fill="none" stroke={props.color} stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" x1="16" y1="25" x2="47.445" y2="25" />
        <polyline fill="none" stroke={props.color} stroke-width="2.08" stroke-linejoin="round" stroke-miterlimit="10" points="31,39 31,49 1,49 1,1 31,1 31,11 " />
    </svg>
);

const TrendsIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" {...props} fill={props.color}>
        <path d="M9.5 7c1.2 0 2.2.8 2.4 2l18.2 91.2c.8 4 4.3 6.8 8.3 6.8h1.2c3.9 0 7.3-2.6 8.2-6.4l12.9-51.7c.3-1.1 1.3-1.9 2.4-1.9h1.4c1.1 0 2.1.8 2.4 1.9L75 80.6c.9 3.8 4.3 6.4 8.2 6.4h1.4c3.9 0 7.3-2.6 8.2-6.4l12-47.9c.4-1.6-.6-3.2-2.2-3.6-1.6-.4-3.2.6-3.6 2.2l-12 47.9c-.3 1.1-1.3 1.9-2.4 1.9h-1.4c-1.1 0-2.1-.8-2.4-1.9L73 47.4C72 43.6 68.6 41 64.7 41h-1.4c-3.9 0-7.3 2.6-8.2 6.4L42.1 99.1c-.3 1.1-1.3 1.9-2.4 1.9h-1.2c-1.2 0-2.2-.8-2.4-2L17.8 7.8C17 3.9 13.5 1 9.5 1 4.8 1 1 4.8 1 9.5V114c0 7.2 5.8 13 13 13l85 0c1.7 0 3-1.3 3-3s-1.3-3-3-3l-85 0c-3.9 0-7-3.1-7-7V9.5C7 8.1 8.1 7 9.5 7zM119 127h5c1.7 0 3-1.3 3-3s-1.3-3-3-3h-5c-1.7 0-3 1.3-3 3S117.3 127 119 127z" />
    </svg>
);

const PromotionIcon = (props) => (
    <svg version="1.1" baseProfile="basic" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 48 48" {...props}>
        <path
            style={{
                fill: "none",
                stroke: props.color,
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10,
            }}
            d="
	M44.85,24c0,2.141-2.29,3.895-2.918,5.827c-0.65,2.003,0.149,4.763-1.064,6.43c-1.225,1.683-4.106,1.77-5.789,2.995
	c-1.667,1.213-2.632,3.933-4.635,4.583C28.512,44.462,26.141,42.85,24,42.85c-2.141,0-4.513,1.612-6.445,0.985
	c-2.003-0.65-2.968-3.37-4.635-4.583c-1.683-1.225-4.564-1.312-5.789-2.995c-1.213-1.667-0.413-4.427-1.063-6.429
	C5.44,27.895,3.15,26.141,3.15,24c0-2.141,2.29-3.895,2.918-5.827c0.65-2.003-0.149-4.763,1.064-6.43
	c1.225-1.683,4.106-1.77,5.789-2.995c1.667-1.213,2.632-3.933,4.635-4.583C19.488,3.538,21.859,5.15,24,5.15
	c2.141,0,4.513-1.612,6.445-0.985c2.003,0.65,2.968,3.37,4.635,4.583c1.683,1.225,4.564,1.312,5.789,2.995
	c1.213,1.667,0.413,4.427,1.063,6.429C42.56,20.105,44.85,21.859,44.85,24z"
        />
        <line
            style={{
                fill: "none",
                stroke: props.color,
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10,
            }}
            x1="18.286"
            y1="32"
            x2="29.714"
            y2="16"
        />
        <circle
            style={{
                fill: "none",
                stroke: props.color,
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10,
            }}
            cx="29"
            cy="29"
            r="3"
        />
        <circle
            style={{
                fill: "none",
                stroke: props.color,
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10,
            }}
            cx="19"
            cy="19"
            r="3"
        />
    </svg>
);

export { CarSelectorIcon, CompetitivenessIcon, BasketIcon, ExportIcon, DashboardIcon, DataCoverageIcon, BrandModelIcon, PromotionIcon, TrendsIcon };
